import moment from "moment";
// import BigNumber from "bignumber.js";
// 金额格式化
function formatMoney() {
  // number, decimals, dec_point, thousands_sep
  //   number = (number + "").replace(/[^0-9+-Ee.]/g, "");
  //   var n = !isFinite(+number) ? 0 : +number,
  //     prec = !isFinite(+decimals) ? 2 : Math.abs(decimals),
  //     sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
  //     dec = typeof dec_point === "undefined" ? "." : dec_point,
  //     s = "",
  //     toFixedFix = function(n, prec) {
  //       var k = Math.pow(10, prec);
  //       return (
  //         "" +
  //         BigNumber(n)
  //           .times(k)
  //           .times(1 / k)
  //           .toNumber()
  //       );
  //     };
  //   s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
  //   var re = /(-?\d+)(\d{3})/;
  //   while (re.test(s[0])) {
  //     s[0] = s[0].replace(re, "$1" + sep + "$2");
  //   }
  //   if ((s[1] || "").length < prec) {
  //     s[1] = s[1] || "";
  //     s[1] += new Array(prec - s[1].length + 1).join("0");
  //   }
  //   return "￥" + s.join(dec);
}

function formatBankAccount(val = "") {
  return val
    .toString()
    .replace(/\s/g, "")
    .replace(/(\d{4})(?=\d)/g, "$1 ");
}
function formatDate(val = "", format = "yyyy-MM-DD") {
  if (!val || !["object", "string", "number"].includes(typeof val)) return "";
  try {
    const replaceValue = typeof val == "string" ? val.replace(/-/g, "/") : val;
    let date = val instanceof Date ? val : new Date(replaceValue);
    let result = moment(date).format(format.replace(/d/g, "D"));
    result === "Invalid date" && console.error("不合法的时间:", val);
    return result === "Invalid date" ? "" : result;
  } catch (error) {
    console.error("时间解析错误:", error);
    return "";
  }
}
function fmtTime(t) {
  if (!t) return "";
  const dfmt = "yyyy/MM/DD";
  const tfmt = "yyyy/MM/DD HH:mm:ss";
  const yfmt = "yyyy";
  const dayStamp = 86400000;
  const weekList = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
  const fmtf = (v1, v2) => formatDate(v1, v2);
  const temp = new Date(fmtf(t, tfmt));
  const now = new Date();
  const tempStamp = temp.getTime();
  const nowStamp = now.getTime();
  if (fmtf(temp, dfmt) == fmtf(now, dfmt)) return fmtf(temp, "HH:mm");
  if (nowStamp - tempStamp <= dayStamp) return "昨天";
  const tStartYear = new Date(temp.getFullYear(), 0, 1);
  const nStartYear = new Date(now.getFullYear(), 0, 1);
  const tDays = Math.ceil((tempStamp - tStartYear.getTime()) / dayStamp);
  const nDays = Math.ceil((nowStamp - nStartYear.getTime()) / dayStamp);
  const tWeeks = Math.ceil(tDays / 7);
  const nWeeks = Math.ceil(nDays / 7);
  if (nWeeks == tWeeks && nDays > tDays) return weekList[temp.getDay()]; /* 本周 */
  if (fmtf(temp, yfmt) == fmtf(now, yfmt)) return fmtf(temp, "MM/DD HH:mm"); /* 本年 */
  return fmtf(temp, "yyyy/MM/DD HH:mm");
}
function fileSize(size) {
  const sizeList = [1024 ** 3, 1024 ** 2, 1024 ** 1, 1024 ** 0]
  const sizeUnitList = ["G", "M", "K", "B"];
  let result = '';
  for (let i = 0; i < sizeList.length; i++) {
    if (size >= sizeList[i]) {
      result = Number((size / sizeList[i]).toFixed(2)) + sizeUnitList[i]
      break;
    }
  }
  return result;
}
export { formatMoney, formatBankAccount, formatDate, fmtTime, fileSize };
